module.exports = __webpack_public_path__ + "img/success.3391dc6c.svg";